
import { defineComponent } from 'vue';
import { Miscellaneous } from '@/constants/Miscellaneous';

export default defineComponent({
    emits: ['callback'],
    data() {
        return {
            list: [{ address1: '', zipCode: '' }]
        };
    },
    methods: {
        callback() {
            this.$emit('callback', this.list);
        },
        addAnotherComp() {
            if (Miscellaneous.ImportLimit > this.list.length) {
                this.list.push({ address1: '', zipCode: '' });
                this.callback();
            }
        },
        removeComp(idx: number) {
            if (this.list.length === 1) {
                this.list[idx].address1 = '';
                this.list[idx].zipCode = '';
            } else {
                this.list.splice(idx, 1);
            }
            this.callback();
        },
        updateAddressValue(idx: number, value: string) {
            this.list[idx].address1 = value.replace(/^\s+/g, '');
            this.callback();
        },
        updateZipValue(idx: number, value: string) {
            this.list[idx].zipCode = value.replace(/^\s+/g, '');
            this.callback();
        }
    }
});
